module.exports = __webpack_public_path__ + "fe38fe573e2399e16d8da5449602070a.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Light.eot
// module id = 374
// module chunks = 0